module.exports = __webpack_public_path__ + "static/media/BLZ.b5bd54f1.png";